exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkbox {\n  background-color: #fff;\n  /* border: solid 1px #d7d7d7; */\n  /* border-radius: 4px; */\n  cursor: pointer;\n  /* display: inline-block; */\n  /* height: 32px; */\n  /* margin-right: 1rem; */\n  text-align: center;\n  /* width: 32px; */\n  /* vertical-align: middle; */\n}\n\nsvg {\n  margin-top: 6px;\n  stroke: #fff;\n}\n\n.positive {\n  background-color: #4aca65;\n  border-color: #43b45b;\n}\n\n.negative {\n  background-color: #dc4e4e;\n  border-color: #c74545;\n}\n\n.label {\n  font-weight: bold;\n  vertical-align: middle;\n}\n", ""]);

// exports
